import script from "./GPCMapper.vue?vue&type=script&setup=true&lang=js"
export * from "./GPCMapper.vue?vue&type=script&setup=true&lang=js"

import "./GPCMapper.vue?vue&type=style&index=0&id=7ad139ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad139ca"]])

export default __exports__